export function Sparky({ className = "", size = 320 }) {
  return (
    <svg
      viewBox="0 0 320 320"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      data-testid="sparky-mascot"
      aria-label="Sparky the robot"
    >
      <defs>
        <linearGradient id="body" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#4361EE" />
          <stop offset="1" stopColor="#2A3EB1" />
        </linearGradient>
        <linearGradient id="face" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#0B1220" />
          <stop offset="1" stopColor="#141B36" />
        </linearGradient>
        <radialGradient id="cheek" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0" stopColor="#F72585" stopOpacity="0.9" />
          <stop offset="1" stopColor="#F72585" stopOpacity="0" />
        </radialGradient>
        <filter id="soft" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="2" />
        </filter>
      </defs>

      {/* antenna */}
      <line x1="160" y1="34" x2="160" y2="58" stroke="#1A1A1A" strokeWidth="6" strokeLinecap="round" />
      <circle cx="160" cy="28" r="10" fill="#FFB703" />
      <circle cx="160" cy="28" r="4" fill="#FFF3C4" />

      {/* head */}
      <rect x="60" y="60" width="200" height="150" rx="42" fill="url(#body)" />
      <rect x="60" y="60" width="200" height="150" rx="42" fill="none" stroke="#0B1220" strokeOpacity="0.15" strokeWidth="4" />

      {/* face screen */}
      <rect x="86" y="92" width="148" height="90" rx="26" fill="url(#face)" />

      {/* eyes */}
      <g>
        <circle cx="130" cy="137" r="12" fill="#4CC9F0" />
        <circle cx="128" cy="134" r="4" fill="#FFFFFF" />
        <circle cx="190" cy="137" r="12" fill="#4CC9F0" />
        <circle cx="188" cy="134" r="4" fill="#FFFFFF" />
      </g>

      {/* smile */}
      <path
        d="M138 162 Q160 178 182 162"
        stroke="#4CC9F0"
        strokeWidth="6"
        strokeLinecap="round"
        fill="none"
      />

      {/* cheeks */}
      <circle cx="96" cy="160" r="16" fill="url(#cheek)" filter="url(#soft)" />
      <circle cx="224" cy="160" r="16" fill="url(#cheek)" filter="url(#soft)" />

      {/* ears */}
      <rect x="46" y="120" width="18" height="36" rx="8" fill="#2A3EB1" />
      <rect x="256" y="120" width="18" height="36" rx="8" fill="#2A3EB1" />

      {/* body / chest */}
      <rect x="86" y="216" width="148" height="70" rx="26" fill="#FFB703" />
      <circle cx="160" cy="252" r="14" fill="#1A1A1A" />
      <path d="M154 252 L158 256 L166 246" stroke="#FFB703" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />

      {/* arms */}
      <rect x="42" y="222" width="34" height="18" rx="9" fill="#4361EE" />
      <rect x="244" y="222" width="34" height="18" rx="9" fill="#4361EE" />

      {/* sparkles */}
      <g fill="#FFB703">
        <path d="M40 70 l4 8 l8 4 l-8 4 l-4 8 l-4 -8 l-8 -4 l8 -4 z" opacity="0.9" />
        <path d="M280 90 l3 6 l6 3 l-6 3 l-3 6 l-3 -6 l-6 -3 l6 -3 z" opacity="0.8" />
        <path d="M56 250 l3 6 l6 3 l-6 3 l-3 6 l-3 -6 l-6 -3 l6 -3 z" opacity="0.7" />
      </g>
    </svg>
  );
}
